module.exports = __webpack_public_path__ + "static/media/envelope.a72c76b8.svg";